import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';
import { NODE_HEIGHT } from '../../../../../utils/dimensions';

interface IconBoxProps {
  color: string;
  hover: boolean;
}

export const IconBox = styled.div<IconBoxProps>`
  background: ${props => (props.hover ? colors.info : props.color)};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${NODE_HEIGHT}px;
  width: ${NODE_HEIGHT}px;
  margin-right: ${sizes.small}px;
  svg,
  path {
    color: ${props => (props.hover ? colors.info : props.color)};
  }
`;
